export default {
  containers: {
    location_info: 'Lokationsinfo',
    attributes: 'Attributter',
    links: 'Links',
  },
  labels: {
    title: 'Titel',
    phone_number: 'Telefonnummer',
    description: 'Beskrivelse',
    website: 'Websted',
    address: 'Adresse',
    regular_hours: 'Almindelige åbningstider',
    page_urls: "Side-URL'er",
    monday: 'Mandag',
    tuesday: 'Tirsdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lørdag',
    sunday: 'Søndag',
    twenty_four_hours: '24 timer',
    open_24_hours: 'Åbent døgnet rundt',
    open_time: 'Åbningstid',
    close_time: 'Lukketid',
    url: 'URL',
    provider_type: 'Udbydertype',
    provider_types: {
      merchant: 'Forhandler',
      aggregator: 'Aggregator',
    },
    place_action_type: 'Type',
    is_preferred: 'Foretrukket',
    place_action_types: {
      appointment: 'Bestilling af tid',
      online_appointment: 'Bestilling af online tid',
      dining_reservation: 'Link til reservationer',
      food_ordering: 'Bestilling af mad til levering og/eller afhentning',
      food_delivery: 'Link til levering',
      food_takeout: 'Link til afhentning',
      shop_online: 'Shopping med levering og/eller afhentning',
    },
    no_links: 'Ingen links tilgængelige for denne virksomhed',
    url_menu: 'Link til menu',
    url_reservations: 'Link til reservationer',
  },
  placeholders: {
    title: 'Titel',
    phone_number: 'Telefonnummer',
    description: 'Beskrivelse',
    website: 'Websted',
    address: 'Adresse',
    regular_hours: 'Almindelige åbningstider',
    page_urls: "Side-URL'er",
    address_line_1: 'Adresselinje 1',
    postal_code: 'Postnummer',
    locality: 'By',
    region_code: 'Regionskode',
    language_code: 'Sprogkode',
    select_time: 'Vælg tidspunkt',
    url: 'URL',
  },
  buttons: {
    submit: 'Send',
    add: 'Tilføj',
    delete: 'Slet',
    generate_description: 'Generer beskrivelse med AI',
  },
  validation: {
    required: 'Dette felt er påkrævet',
    invalid_url: 'Ugyldig URL',
  },
  toasts: {
    success: 'Ændringerne er gemt!',
    description_generation_failed: 'Kunne ikke generere en beskrivelse. Prøv igen.',
  },
};
